import { render, staticRenderFns } from "./AdditionalInfosSection.vue?vue&type=template&id=bdc1c870&"
import script from "./AdditionalInfosSection.vue?vue&type=script&lang=js&"
export * from "./AdditionalInfosSection.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalInfosSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports